import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
declare var reset_slider4: Function;
//declare var reset_slider: Function;

@Component({
  selector: 'app-how-its-work',
  templateUrl: './how-its-work.component.html',
  styleUrls: ['./how-its-work.component.css','../../assets/css/how-its-work/fee3186e-1568118466.min.css']
})
export class HowItsWorkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  setTimeout(() => {
    reset_slider4('.owl-carousel-icons-vis');
    //reset_slider('.owl-carousel-assoc-fix');  
    }, 500);  
  }

}
